import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import AddQuotation from "../../../component/AddQuotation";
import { UsedCarLoanDetailReducer } from "./UsedCarLoanSlice";
import moment from "moment";
import ViewImageModal from "../../../component/ViewImageModal";

function UsedCarLoanRequests() {
  const [ReqId, setReqId] = useState("");
  const [show, setShow] = useState(false);
  const [modalName, setModalName] = useState("");
  const [imgSRC, setimgSRC] = useState("");
  const [imgName, setimgName] = useState("");
  const [img, setimg] = useState({});
  const handleShow = () => {
    setShow(!show);
  };
  const { id } = useParams();
  const dispatch = useDispatch();

  const detail = useSelector((store) => store.UsedCarLoan.details);
  //console.log(detail);

  const getdetail = useCallback(() => {
    dispatch(
      UsedCarLoanDetailReducer({
        id: id,
      })
    );
  }, [dispatch, id]);

  useEffect(() => {
    let isrander = false;
    if (!isrander) {
      getdetail();
    }

    return () => {
      isrander = false;
    };
  }, [getdetail]);
  return (
    <>
      <article className="col-lg-9">
        <div className="article-body store-bd-gy">
          <div className="row align-items-center col-rever">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <h2 className="head-title">Used Car Loan</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12 mt-4 text-center">
              <img
                src={
                  detail?.serviceDetails?.image || "assets/images/employe.png"
                }
                className="img-fluid srvsIcon"
                alt=""
              />
            </div>
            <div className="col-sm-12 mb-4">
              <div className="col-sm-12 mt-4">
                <h2>User Detail</h2>
              </div>

              <div className="col-sm-12 mb-4">
                <div className="view-detail mt-0">
                  <div className="table-responsive pt-4">
                    <table className="table table-borderless">
                      <tbody>
                        <tr>
                          <td>
                            <img
                              src="assets/images/Full-Name.png"
                              className="detail-icon"
                              alt=""
                            />{" "}
                            First Name
                          </td>
                          <td>
                            <img
                              src="assets/images/Full-Name.png"
                              className="detail-icon"
                              alt=""
                            />{" "}
                            Last Name
                          </td>
                          <td>
                            <img
                              src="assets/images/mobile-nu.png"
                              className="detail-icon"
                              alt=""
                            />{" "}
                            Mobile Number{" "}
                          </td>
                          <td>
                            <img
                              src="assets/images/Email-Address.png"
                              className="detail-icon"
                              alt=""
                            />{" "}
                            personal Email
                          </td>
                          <td>
                            <img
                              src="assets/images/Email-Address.png"
                              className="detail-icon"
                              alt=""
                            />{" "}
                            official Email
                          </td>
                        </tr>
                        <tr>
                          <th>{detail?.userDetails?.first_name || "NA"}</th>
                          <th>{detail?.userDetails?.last_name || "NA"}</th>
                          <th>
                            {detail?.userDetails?.mobile
                              ? `${detail?.userDetails?.countryCode} ${detail?.userDetails?.mobile}`
                              : "NA"}
                          </th>
                          <th>{detail?.userDetails?.personal_email || "NA"}</th>
                          <th>{detail?.userDetails?.official_email || "NA"}</th>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mb-4">
                <h2>Vehicle Detail</h2>
              </div>
              <div className="view-detail mt-0">
                <div className="table-responsive pt-4">
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src="assets/images/REGN-No-Initials.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          Vehicle Regn No
                        </td>
                        <td>
                          <img
                            src="assets/images/OEM-Make.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          Make{" "}
                        </td>
                        <td>
                          <img
                            src="assets/images/Model.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          Modal
                        </td>
                        <td>
                          <img
                            src="assets/images/Fuel.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          Fuel
                        </td>
                        <td>
                          <img
                            src="assets/images/Month-Year-of-Regn.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          Regn Year
                        </td>
                      </tr>
                      <tr>
                        <th>{detail?.vehicle_regn_no || "NA"}</th>
                        <th>{detail?.make || "NA"}</th>
                        <th>{detail?.model || "NA"}</th>
                        <th>{detail?.fuel || "NA"}</th>
                        <th>{detail?.regn_year || "NA"}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-sm-12 mb-4">
              <h2>Required Images</h2>
            </div>
            <div className="col-sm-12 mb-4">
              <div className="view-detail mt-0">
                <div className="row">
                  <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
                    <h3 className="mb-2 pt-3 theme-color">RC Front Image</h3>
                    <img
                      src={
                        detail?.documentDetails?.rc_front_image ||
                        "assets/images/employe.png"
                      }
                      className="img-fluid idImages"
                      alt=""
                      onClick={() => {
                        setModalName("ViewImage");
                        setimgSRC("documentDetails.rc_front_image");
                        setimgName(detail?.documentDetails?.rc_front_image_name || "rc_front_image_name");

                        handleShow();
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
                    <h3 className="mb-2 pt-3 theme-color">RC Back Image</h3>
                    <img
                      src={
                        detail?.documentDetails?.rc_back_image ||
                        "assets/images/employe.png"
                      }
                      className="img-fluid idImages"
                      alt=""
                      onClick={() => {
                        setModalName("ViewImage");
                        setimgSRC("documentDetails.rc_back_image");
                        setimgName(detail?.documentDetails?.rc_back_image_name || "rc_back_image_name");
                        handleShow();
                      }}
                    />
                  </div>

                  <div className="col-sm-12 mt-4">
                    <h2>Applicant Details</h2>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
                    <div className="table-responsive pt-4">
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src="assets/images/Full-Name.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              First Name
                            </td>
                            <td>
                              <img
                                src="assets/images/Full-Name.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              Last Name
                            </td>
                            <td>
                              <img
                                src="assets/images/mobile-nu.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              Mobile Number
                            </td>
                            <td>
                              <img
                                src="assets/images/Email-Address.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              Email
                            </td>
                            <td>
                              <img
                                src="assets/images/stereo.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              pan
                            </td>
                          </tr>
                          <tr>
                            <th>
                              {detail?.usedCarLoanDetails?.first_name || "NA"}
                            </th>
                            <th>
                              {detail?.usedCarLoanDetails?.last_name || "NA"}
                            </th>
                            <th>
                              {detail?.usedCarLoanDetails?.mobile_number
                                ? `${detail?.usedCarLoanDetails?.country_code} ${detail?.usedCarLoanDetails?.mobile_number}`
                                : "NA"}
                            </th>
                            <th>{detail?.usedCarLoanDetails?.email || "NA"}</th>
                            <th>
                              {detail?.usedCarLoanDetails?.pan_no || "NA"}
                            </th>
                          </tr>
                          <tr>
                            <td className="py-4" colSpan="6">
                              <hr />
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <img
                                src="assets/images/Date-of-Birth.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              DOB
                            </td>
                            <td>
                              <img
                                src="assets/images/Price.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              Occupation
                            </td>
                            <td>
                              <img
                                src="assets/images/Current-Car-Location.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              current residence
                            </td>
                            <td>
                              <img
                                src="assets/images/Current-Car-Location.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              city stability
                            </td>
                          </tr>
                          <tr>
                            <th>
                              {" "}
                              {moment(
                                detail?.usedCarLoanDetails?.dob,
                                "YYYY MM DD"
                              ).format("DD MMM YYYY")}
                            </th>
                            <th>
                              {detail?.usedCarLoanDetails?.occupation || "NA"}
                            </th>
                            <th>
                              {detail?.usedCarLoanDetails?.current_residence ||
                                "NA"}
                            </th>
                            <th>
                              {detail?.usedCarLoanDetails?.city_stability ||
                                "NA"}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="col-sm-12 mt-4">
                    <h2>Applicant ID & Address</h2>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
                    <h3 className="mb-2 pt-3 theme-color">Applicant ID</h3>
                    <img
                      src={
                        detail?.usedCarLoanDetails?.applicant_id_file_path ||
                        "assets/images/employe.png"
                      }
                      className="img-fluid idImages"
                      alt=""
                      onClick={() => {
                        setModalName("ViewImage");
                        setimgSRC("usedCarLoanDetails.applicant_id_file_path");
                        setimgName(detail?.usedCarLoanDetails?.applicant_id_file_name || "applicant_id_file_name");
                        handleShow();
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
                    <h3 className="mb-2 pt-3 theme-color">Applicant Address</h3>
                    <img
                      src={
                        detail?.usedCarLoanDetails
                          ?.applicant_address_file_path ||
                        "assets/images/employe.png"
                      }
                      className="img-fluid idImages"
                      alt=""
                      onClick={() => {
                        setModalName("ViewImage");
                        setimgSRC(
                          "usedCarLoanDetails.applicant_address_file_path"
                        );
                        setimgName(detail?.usedCarLoanDetails
                          ?.applicant_address_file_name
                          || "applicant_address_file_name");
                        handleShow();
                      }}
                    />
                  </div>
                  <div className="col-sm-12 mt-4">
                    <h2>Required Loan Details</h2>
                  </div>
                  <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
                    <div className="table-responsive pt-4">
                      <table className="table table-borderless">
                        <tbody>
                          <tr>
                            <td>
                              <img
                                src="assets/images/Price.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              Amount
                            </td>
                            <td>
                              <img
                                src="assets/images/Date-of-Birth.png"
                                className="detail-icon"
                                alt=""
                              />{" "}
                              tenure (in Years)
                            </td>
                          </tr>
                          <tr>
                            <th>
                              {detail?.usedCarLoanDetails?.amount || "NA"}
                            </th>
                            <th>
                              {detail?.usedCarLoanDetails?.tenure_in_year ||
                                "NA"}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-12 mb-4">
              <h2>Payment Detail</h2>
            </div>
            <div className="col-sm-12 mb-4">
              <div className="view-detail mt-0">
                <div className="table-responsive pt-4">
                  <table className="table table-borderless">
                    <tbody>
                      <tr>
                        <td>
                          <img
                            src="assets/images/REGN-No-Initials.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          amount
                        </td>
                        <td>
                          <img
                            src="assets/images/Model.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          transaction Id
                        </td>
                        <td>
                          <img
                            src="assets/images/OEM-Make.png"
                            className="detail-icon"
                            alt=""
                          />{" "}
                          order Id{" "}
                        </td>
                      </tr>
                      <tr>
                        <th>{detail?.paymentDetails?.amount || "NA"}</th>
                        <th>{detail?.paymentDetails?.transactionId || "NA"}</th>
                        <th>{detail?.paymentDetails?.orderId || "NA"}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div> */}
            <div className="col-sm-12">
              <div className="view-btns">
                {/* {detail?.quotation_pdf === null ? (
                  <button
                    className="btn btn-reject btn-view mt-2"
                    onClick={() => {
                      setReqId(detail?.id);
                      setModalName("AddQuotation");
                      handleShow();
                    }}
                  >
                    Add Quotation
                  </button>
                ) : (
                  ""
                )} */}
              </div>
            </div>
          </div>
        </div>
        {show && modalName === "AddQuotation" && (
          <AddQuotation
            show={show}
            handleShow={handleShow}
            ReqId={ReqId}
            getList={getdetail}
          />
        )}
        {detail[imgSRC.split(".")[0]] &&
          imgSRC &&
          modalName === "ViewImage" && (
            <ViewImageModal
              show={show}
              handleShow={handleShow}
              imgSRC={imgSRC}
              image={detail}
              setitem={setimg}
              setimgSRC={setimgSRC}
              imageName={imgName}
            />
          )}
      </article>
    </>
  );
}

export default UsedCarLoanRequests;
